import { render } from "./GalleryCards.vue?vue&type=template&id=4da6fb94"
import script from "./GalleryCards.vue?vue&type=script&lang=js"
export * from "./GalleryCards.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__